import React from "react";
import { tv } from "tailwind-variants";
import chevronRightWhite from "../../../assets/Chevron/ChevronRight_White.svg";
import chevronRightRed from "../../../assets/Chevron/ChevronRight_Red.svg";

export type ButtonProps = {
  label?: string;
  onClick?: () => void;
  className?: string;
  variant?: "solid" | "outline" | "pillGray" | "ghostBrand";
  tone?: "brand" | "gray";
  disabled?: boolean;
  dataName?: string;
  dataNodeId?: string;
  iconSrc?: string;
  iconClassName?: string;
};

const buttonStyles = tv({
  base: "inline-flex items-center justify-center gap-s-050 rounded-btnA px-s-400 py-s-200",
  variants: {
    variant: {
      solid: "bg-brandOrange text-white h-btnSm min-w-[98px] shadow-btnAInset",
      outline: "border h-btnSm min-w-[98px]",
      pillGray: "bg-borderGray text-brandOnBrandText rounded-pill",
      ghostBrand: "text-brandOrange",
    },
    tone: {
      brand: "",
      gray: "",
    },
    disabled: {
      true: "opacity-60 cursor-not-allowed pointer-events-none",
      false: "",
    },
  },
  compoundVariants: [
    {
      variant: "outline",
      tone: "brand",
      class: "text-brandOrange border-brandOrange",
    },
    {
      variant: "outline",
      tone: "gray",
      class: "text-borderGray border-borderGray",
    },
  ],
  defaultVariants: {
    variant: "solid",
    tone: "brand",
    disabled: false,
  },
});

export function Button({
  label = "ボタン",
  onClick,
  className = "",
  variant = "solid",
  tone = "brand",
  disabled = false,
  dataName = "Button",
  dataNodeId = "1289:10731",
  iconSrc,
  iconClassName,
}: ButtonProps) {
  const resolvedIconSrc = disabled
    ? chevronRightWhite
    : (iconSrc ?? (variant === "solid" ? chevronRightWhite : chevronRightRed));
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={
        buttonStyles({ variant, tone, disabled }) +
        (className ? ` ${className}` : "")
      }
      data-name={dataName}
      data-node-id={dataNodeId}
    >
      <img
        src={resolvedIconSrc}
        alt=""
        className={iconClassName || "w-4 h-4"}
        aria-hidden="true"
      />
      <span className="text-sm font-semibold leading-body">{label}</span>
    </button>
  );
}

export default Button;
